import SearchIcon from "@mui/icons-material/Search";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import SecurityIcon from "@mui/icons-material/Security";
import FlightIcon from "@mui/icons-material/Flight";
import TrainIcon from "@mui/icons-material/Train";
import PlaceIcon from "@mui/icons-material/Place";
import DirectionsBoatFilledIcon from "@mui/icons-material/DirectionsBoatFilled";

export const SELLER_COLOR = "#008000";
export const BUYER_COLOR = "#FF0000";
export const TABLE_BORDER = "1px solid #000";

export const RESPONSIBILITY_FIELDS = [
  "packagingAndVerification",
  "loading",
  "originTransport",
  "exportCustoms",
  "handlingAtOrigin",
  "mainTransport",
  "transportInsurance",
  "handlingAtDestination",
  "importCustoms",
  "destinationTransport",
  "delivery",
];

export const STAGE_COLUMNS = [
  {
    field: "packagingAndVerification",
    icon: SearchIcon,
    iconBg: "#8BC34A",
    labelKey: "columns.packagingAndVerification",
  },
  {
    field: "loading",
    icon: Inventory2Icon,
    iconBg: "#FF9800",
    labelKey: "columns.loading",
  },
  {
    field: "originTransport",
    icon: LocalShippingIcon,
    iconBg: "#795548",
    labelKey: "columns.originTransport",
  },
  {
    field: "exportCustoms",
    icon: AssignmentIcon,
    iconBg: "#607D8B",
    labelKey: "columns.exportCustoms",
  },
  {
    field: "handlingAtOrigin",
    icon: WarehouseIcon,
    iconBg: "#9C27B0",
    labelKey: "columns.handlingAtOrigin",
  },
  {
    field: "mainTransport",
    icon: DirectionsBoatIcon,
    iconBg: "#1565C0",
    labelKey: "columns.mainTransport",
  },
  {
    field: "transportInsurance",
    icon: SecurityIcon,
    iconBg: "#F44336",
    labelKey: "columns.transportInsurance",
  },
  {
    field: "handlingAtDestination",
    icon: WarehouseIcon,
    iconBg: "#9C27B0",
    labelKey: "columns.handlingAtDestination",
  },
  {
    field: "importCustoms",
    icon: AssignmentIcon,
    iconBg: "#607D8B",
    labelKey: "columns.importCustoms",
  },
  {
    field: "destinationTransport",
    icon: LocalShippingIcon,
    iconBg: "#795548",
    labelKey: "columns.destinationTransport",
  },
  {
    field: "delivery",
    icon: PlaceIcon,
    iconBg: "#4CAF50",
    labelKey: "columns.delivery",
  },
];

export const TRANSPORT_MODES = {
  maritime: {
    icon: DirectionsBoatFilledIcon,
    color: "#1565C0",
    labelKey: "transport.maritime",
  },
  road: {
    icon: LocalShippingIcon,
    color: "#795548",
    labelKey: "transport.road",
  },
  air: {
    icon: FlightIcon,
    color: "#2E7D32",
    labelKey: "transport.air",
  },
  rail: {
    icon: TrainIcon,
    color: "#E65100",
    labelKey: "transport.rail",
  },
};

export const INCOTERMS_ACCENT = "#1565C0";
